import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { colors, spacing, typography } = themeVariables;

// Sized so a 1440px page fits four columns, as the design does, rather than
// five: one column on a phone, two on a tablet, four at full width.
const MIN_CARD_WIDTH = '280px';

export const heading = css`
  margin: 0 0 var(${spacing.md});
  font-family: var(${typography.heading.fontFamily});
  font-weight: var(${typography.heading.fontWeight});
  font-size: var(${typography.heading.sizes.md.fontSize});
  line-height: var(${typography.heading.sizes.md.lineHeight});
  letter-spacing: var(${typography.heading.letterSpacing});
  color: var(${colors.content.default});
`;

/* Columns follow the space the listing is given, not the viewport. */
export const grid = css`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, ${MIN_CARD_WIDTH}), 1fr));
  gap: var(${spacing.lg}) var(${spacing.sm});
  margin: 0;
  padding: 0;
  list-style: none;
`;
